module.exports = __webpack_public_path__ + "static/media/destination_image_1.4d218edb.webp";